"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvidenceLinkNotFoundError = exports.EvidenceLinkSliceNotSupportedError = exports.InvalidEvidenceLinkObjectError = exports.EvidenceTopicTagForbiddenError = exports.UnknownEvidenceTopicError = exports.EvidenceLocatorNotFoundError = exports.EvidenceVoterKeyError = exports.EvidenceVoterIdentityError = exports.InvalidEvidenceAddressError = void 0;
exports.isInvalidEvidenceAddressError = isInvalidEvidenceAddressError;
exports.isEvidenceVoterIdentityError = isEvidenceVoterIdentityError;
exports.isEvidenceVoterKeyError = isEvidenceVoterKeyError;
exports.isEvidenceLocatorNotFoundError = isEvidenceLocatorNotFoundError;
exports.isUnknownEvidenceTopicError = isUnknownEvidenceTopicError;
exports.isEvidenceTopicTagForbiddenError = isEvidenceTopicTagForbiddenError;
exports.isInvalidEvidenceLinkObjectError = isInvalidEvidenceLinkObjectError;
exports.isEvidenceLinkSliceNotSupportedError = isEvidenceLinkSliceNotSupportedError;
exports.isEvidenceLinkNotFoundError = isEvidenceLinkNotFoundError;
class InvalidEvidenceAddressError extends Error {
    constructor(address, reason) {
        super(`Invalid evidence address '${address}': ${reason}`);
        this.name = this.constructor.name;
        this.address = address;
    }
}
exports.InvalidEvidenceAddressError = InvalidEvidenceAddressError;
function isInvalidEvidenceAddressError(error) {
    return error instanceof InvalidEvidenceAddressError;
}
class EvidenceVoterIdentityError extends Error {
    constructor(agency, missingField) {
        super(`Cannot derive an evidence voter key for agency '${agency}' without ${missingField}`);
        this.name = this.constructor.name;
        this.agency = agency;
        this.missingField = missingField;
    }
}
exports.EvidenceVoterIdentityError = EvidenceVoterIdentityError;
function isEvidenceVoterIdentityError(error) {
    return error instanceof EvidenceVoterIdentityError;
}
class EvidenceVoterKeyError extends Error {
    constructor(voterKey) {
        super(`Evidence voter key '${voterKey}' names no known voter kind`);
        this.name = this.constructor.name;
        this.voterKey = voterKey;
    }
}
exports.EvidenceVoterKeyError = EvidenceVoterKeyError;
function isEvidenceVoterKeyError(error) {
    return error instanceof EvidenceVoterKeyError;
}
class EvidenceLocatorNotFoundError extends Error {
    constructor(address) {
        super(`No evidence region is recorded at '${address}'`);
        this.name = this.constructor.name;
        this.address = address;
    }
}
exports.EvidenceLocatorNotFoundError = EvidenceLocatorNotFoundError;
function isEvidenceLocatorNotFoundError(error) {
    return error instanceof EvidenceLocatorNotFoundError;
}
class UnknownEvidenceTopicError extends Error {
    constructor(topic) {
        super(`Evidence topic '${topic}' is not registered`);
        this.name = this.constructor.name;
        this.topic = topic;
    }
}
exports.UnknownEvidenceTopicError = UnknownEvidenceTopicError;
function isUnknownEvidenceTopicError(error) {
    return error instanceof UnknownEvidenceTopicError;
}
class EvidenceTopicTagForbiddenError extends Error {
    constructor(address, topic) {
        super(`Region '${address}' is not tagged with topic '${topic}', and this voter may not add it`);
        this.name = this.constructor.name;
        this.address = address;
        this.topic = topic;
    }
}
exports.EvidenceTopicTagForbiddenError = EvidenceTopicTagForbiddenError;
function isEvidenceTopicTagForbiddenError(error) {
    return error instanceof EvidenceTopicTagForbiddenError;
}
class InvalidEvidenceLinkObjectError extends Error {
    constructor(object, reason) {
        super(`Invalid evidence link object '${object}': ${reason}`);
        this.name = this.constructor.name;
        this.object = object;
    }
}
exports.InvalidEvidenceLinkObjectError = InvalidEvidenceLinkObjectError;
function isInvalidEvidenceLinkObjectError(error) {
    return error instanceof InvalidEvidenceLinkObjectError;
}
class EvidenceLinkSliceNotSupportedError extends Error {
    constructor(sliceKey) {
        super(`Rows of slice '${sliceKey}' cannot carry evidence links`);
        this.name = this.constructor.name;
        this.sliceKey = sliceKey;
    }
}
exports.EvidenceLinkSliceNotSupportedError = EvidenceLinkSliceNotSupportedError;
function isEvidenceLinkSliceNotSupportedError(error) {
    return error instanceof EvidenceLinkSliceNotSupportedError;
}
class EvidenceLinkNotFoundError extends Error {
    constructor(locatorAddress) {
        super(`Region '${locatorAddress}' is not linked to any of the selected rows`);
        this.name = this.constructor.name;
        this.locatorAddress = locatorAddress;
    }
}
exports.EvidenceLinkNotFoundError = EvidenceLinkNotFoundError;
function isEvidenceLinkNotFoundError(error) {
    return error instanceof EvidenceLinkNotFoundError;
}
//# sourceMappingURL=evidence.errors.js.map